<template>
	<div id="LoadingSpinner" class="fullscreen-centered always-on-top dark-stars">
		<div>
			<Logo/>
			<div class="loading-message loading-dots">Loading</div>
		</div>
	</div>
</template>

<script>
	import Logo from "@/components/Logo.vue";

	export default {
		name: 'LoadingSpinner',
		components: {
			Logo
		},
	}
</script>

<style>
	#LoadingSpinner .loading-message { animation: pulse 1.65s infinite linear; }
</style>